module.exports = __webpack_public_path__ + "static/media/appointed.d46d7db1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/appointed.mp3
// module id = 612
// module chunks = 1